import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl,SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import {
  UserModel,
  Chartgoogle ,
  datawidget,
  datawidgetUser
} from 'src/app/models/auth/_models/user.model';
import {
  DxFormComponent
} from 'devextreme-angular';
import { MicroApplication } from 'src/app/services/microapplications/_models/microapplication.model';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { MessagesService } from 'src/app/services/service.index';
import { ChartType } from 'angular-google-charts';
import { Location } from '@angular/common'
import { v4 as uuid } from "uuid";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-widget-config',
  templateUrl: './widget-config.component.html',
  styleUrls: ['./widget-config.component.css'],
})
export class WidgetConfigComponent implements OnInit {
  formId = uuid();
  @ViewChild(DxFormComponent, { static: false }) myform: DxFormComponent;
  public sessionData = JSON.parse(
    sessionStorage.getItem('sessionData') || '{}'
  );
  @Input() widget: MicroApplication;
  UserList:  datawidgetUser[]
  UserListselect: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  saveButtonOptions: any;
  userlistconcat:string;
  deleteButtonOptions: any;
  widgetApploaded:datawidget = new datawidget();
  
  microApploaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  widgetdata: datawidget = new datawidget();
  widgetdatasave: datawidget[];
  chartgoogle: Chartgoogle [] = [];
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>(
    ''
  );
  urlObserver$: Observable<SafeResourceUrl>;
  style: string;
  data: any;

  

  chart = {
    type: 'PieChart',
    data: [
      ['Task', 'Hours per Day'],
      ['Work', 11],
      ['Eat', 2],
      ['Commute', 2],
      ['Watch TV', 2],
      ['Sleep', 7],
    ],
    columnNames: ['Task', 'Hours per Day'],
    options: {
      is3D: true,
    },
  };

  //  type = ChartType.ColumnChart;
  type = ChartType.Table;
  dataArray: string[];
  //  datar = [
  //     ['Firefox', 45.0],
  //     ['IE', 26.8],
  //     ['Chrome', 12.8],
  //     ['Safari', 8.5],
  //     ['Opera', 6.2],
  //     ['Others', 0.7]
  //  ];

  datar = [
    ['BRAZIL', 7153282.26, 6243680.89],
    ['CANADA', 3593833.71, 4759069.35],
    ['CHILE', 1363314.23, 1108712.94],
    ['MEXICO', 982280.0, 354999.48],
    ['PANAMA', 0.0, 0.0],
    ['UNITED STATES', 7592720.0, 5820093.76],
  ];
  columnNames = ['Browser', 'Percentage'];
  options = {};
  width = 550;
  height = 400;
  keyValueArray: [string, string][];
  dataA: any;
  user$: Observable<UserModel>;
  conpany: string;
  datg: any;
  editMode = false;
  fgt: { key: string; value: unknown[] }[];
  jsonObject: any;
  backOptions: any;
  insertMode = false;
  title: any;
  typewidgets: any;
  textwid_ssql: any;
  statuswidgets: any;
  public domSanitizer: DomSanitizer
  usu_code: any;
  popupvisibleusuer: boolean;

  id: string;
  name: string;
  imageSrc: SafeUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private auth: AuthService,
    private _messagesService: MessagesService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    public microApps: MicroapplicationService
  ) {
    this.urlObserver$ = this.url.asObservable();

    this.backOptions = {
      icon: "undo",
      hint: "Atrás",
      onClick: () => {
        this.goback();
      },
    };

    this.saveButtonOptions = {
      icon: "save",
      hint: "Guardar",
      onClick: () => {
        this.save();
      },
    };
    this.deleteButtonOptions = {
      icon: "trash",
      hint: "Eliminar",
      onClick: () => {
        this.delete();
      },
    };
    
  }
  Status: any[] = [
    { id: "A", name: 'Activo' },
    { id: "I", name: 'Inactivo' }
    // Añade más objetos si es necesario
]

tipWid: any[] = [
  { id: "T", name: 'Tablero' },
  { id: "B", name: 'Barras'  },
  { id: "A", name: 'Area' },
  { id: "C", name: 'Grafico' },
  // Añade más objetos si es necesario
]

  ngOnInit(): void {
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.conpany = this.sessionData.selectedCompany.code;
    this.usu_code = this.sessionData.accountCode;

    this.activatedRoute.queryParams.subscribe((params) => {
      const { pId: id, wId: wid } = params;
      if (id) {
        this.editMode = true;
        this.loadWidget(id, wid);
        this.Userlist(wid);
        this.Userlistadd();
      } else {
        this.insertMode = true;
        this.microApploaded.next(true);
      }
    });

    // this.loadDataWidgets();
  }

  private loadWidget(id: string, wid: string): void {
    this.microApps.GetwidgetById(id, wid).subscribe(
      (resp) => {
        if (resp.isSuccessful) {
          this.microApploaded.next(true);
          Object.assign(this.widgetdata, resp.result[0]);
        }
      },
      (error) => this._messagesService.error(error)
    );
  }

  // private loadDataWidgets(): void {
  //   this.microApps.WidgetsList(this.conpany).subscribe(
  //     (resp) => {
  //       if (resp.isSuccessful) {
  //         this.chartgoogle = resp.result.map(widget => ({
  //           data: widget.json,
  //           type: widget.wid_tiwd === 'T' ? ChartType.Table : ChartType.PieChart,
  //           columnNames: widget.columnnames,
  //           title: widget.wid_desc,
  //           height: 550,
  //           width: 400,
  //         }));
  //       } else {
  //         this._messagesService.error(resp.errorMessage);
  //       }
  //     },
  //     (error) => this._messagesService.error(error)
  //   );
  // }

  async  getBase64ImageFromUrl(imageUrl) {
    let res = await fetch(imageUrl);
    let blob = await res.blob();
  
    return new Promise((resolve, reject) => {
      let reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);
  
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  goback() {
    // this.router.navigate(["microapplication/microapplication-list"]);
    this.location.back();
  }

  onValueChangedtext(data:any){
    this.textwid_ssql=data.value;
    this.widgetdata.wid_ssql= this.textwid_ssql;
  }
  onValueChangedSelect(data:any){
    this.typewidgets=data.value;
    this.widgetdata.wid_tiwd= this.typewidgets;
  }

  onValueChangedSelectStatus(data:any){
    this.statuswidgets=data.value;
    this.widgetdata.aud_esta= this.statuswidgets;
  }

  delete(){
    this.widgetdatasave = [];
    this.widgetdatasave.push({
      aud_esta: this.widgetdata.aud_esta,
      aud_ufac:this.widgetdata.aud_ufac,
      aud_usua:this.usu_code,
      emp_codi:this.conpany,
      wid_cont: this.widgetdata.wid_cont,
      wid_fech:this.widgetdata.wid_fech,
      wid_nomb: this.widgetdata.wid_nomb,
      wid_ssql:this.widgetdata.wid_ssql,
      wid_titl: this.widgetdata.wid_titl,
      wid_tiwd:this.widgetdata.wid_tiwd,
      usu_list:this.userlistconcat
       
    });

    this.microApps.GetwidgetByIddelete(this.conpany,this.usu_code, this.widgetdatasave).subscribe(result => {
      if (result.isSuccessful) {
              this._messagesService.success('Datos Eliminados')
              this.goback();
            }
        else {
          this._messagesService.error(result.errorMessage)
        }
      });
  }

  save() {
  
    let result = this.myform.instance.validate();

    this.widgetdatasave = [];

    if(!this.widgetdata.wid_ssql){
      this._messagesService.warning("Sentecia es obligatoria")
      return
    }

    if(!this.widgetdata.wid_tiwd){
      this._messagesService.warning("Tipo Widget es obligatoria")
      return
    }
 
    if (result.isValid==true) {


      const loweredSQL = this.widgetdata.wid_ssql.toLowerCase();

      // Validación general
      const forbiddenKeywords = ['drop', 'delete', 'update', 'insert', 'alter'];
      if (forbiddenKeywords.some(k => loweredSQL.includes(k))) {
        this._messagesService.warning('La consulta contiene comandos no permitidos.');
        return false;
      }
    
      // Validaciones por tipo de gráfico
      switch (this.widgetdata.wid_tiwd) {
        case 'T': // Tabla
          return loweredSQL.includes('select');
    
        case 'C': // PieChart requiere 2 columnas: categoría y valor
          if (!this.hasExpectedColumnCount(this.widgetdata.wid_ssql, 2)) {
            this._messagesService.warning('Un gráfico de torta requiere exactamente 2 columnas: categoría y valor.');
            return false;
          }
          return true;
    
        case 'A': // AreaChart espera al menos 2 columnas numéricas
        case 'B': // BarChart también
          if (!this.hasExpectedColumnCount(this.widgetdata.wid_ssql, 2)) {
            this._messagesService.warning('Este tipo de gráfico requiere al menos 2 columnas.');
            return false;
          }
      }


      // this.microApps.loadingSubject.next(true);
      if (this.insertMode) {

        this.widgetdatasave.push({
         aud_esta: this.widgetdata.aud_esta,
         aud_ufac:this.widgetdata.aud_ufac,
         aud_usua:this.usu_code,
         emp_codi:this.conpany,
         wid_cont: this.widgetdata.wid_cont,
         wid_fech:this.widgetdata.wid_fech,
         wid_nomb: this.widgetdata.wid_nomb,
         wid_ssql:this.widgetdata.wid_ssql,
         wid_titl: this.widgetdata.wid_titl,
         wid_tiwd:this.widgetdata.wid_tiwd,
         usu_list:this.userlistconcat
    
        });

this.GetwidgetByIdupdate()
      }
      else{

    
        this.widgetdatasave.push({
         aud_esta: this.widgetdata.aud_esta,
         aud_ufac:this.widgetdata.aud_ufac,
         aud_usua:this.widgetdata.aud_usua,
         emp_codi:this.widgetdata.emp_codi,
         wid_cont: this.widgetdata.wid_cont,
         wid_fech:this.widgetdata.wid_fech,
         wid_nomb: this.widgetdata.wid_nomb,
         wid_ssql:this.widgetdata.wid_ssql,
         wid_titl: this.widgetdata.wid_titl,
         wid_tiwd:this.widgetdata.wid_tiwd,
         usu_list:this.userlistconcat
    
        });
    
this.GetwidgetByIdupdate();

        this.microApps.GetwidgetByIdsave(this.conpany,this.usu_code, this.widgetdatasave).subscribe(result => {
          if (result.isSuccessful) {
         
                  this._messagesService.success('Datos ingresados')
                  this.goback();
                }
            else {
              this._messagesService.error(result.errorMessage)
            }
          });
      }

    }
    else{
      this._messagesService.error("Por favor ingresar los datos obligatorios")
    }
    // }

  }

  GetwidgetByIdsave(){

  }

  GetwidgetByIdupdate()
  {
        this.microApps.GetwidgetByIdupdate(this.conpany,this.usu_code, this.widgetdatasave).subscribe(result => {
          if (result.isSuccessful) {
         
                  this._messagesService.success('Datos Actualizados')
                  this.goback();
                }
            else {
              this._messagesService.error(result.errorMessage)
            }
          });
    
  }

 Userlist(widcont :string){
    this.microApps.GetUserList(widcont).subscribe(resp => {
      if (resp.isSuccessful) {
  
        this.UserList =resp.result;
      }
      else {

        this._messagesService.error(resp.errorMessage);
 
      }
    });
  }

  qbeButtonuser(){
    this.popupvisibleusuer = true;
  };


  Userlistadd(){
    this.microApps.GetUserListadd().subscribe(resp => {
      if (resp.isSuccessful) {
        this.UserListselect.next(resp.result);
      }
      else {

        this._messagesService.error(resp.errorMessage);
 
      }
    });
  }

  onRowDblClick(data: any) {
    if(!this.UserList){
      this.UserList = [];
    }
  

    for (let order of this.UserList) {
      let match = this.UserList.filter((order) => order.usu_codi == data.data.usu_codi);
      if (match.length >= 1) {
        this.popupvisibleusuer=false;
        this._messagesService.info('Usuario ya selecionado');
              return;
      }
      // match ? this.dataaddp.splice(this.dataaddp.indexOf(order), 1) : null;

    }

    this.popupvisibleusuer=false;

    this.UserList.push({
      usu_codi: data.data.usu_codi,
      usu_nomb:data.data.usu_nomb
    })
    this.userlistconcat = this.userlistconcat + ';' + data.data.usu_codi
  }

    
    onRowRemoving(event: any) {
      const userCode = event.data.usu_codi; // Obtén el código del usuario que se va a eliminar
      this.userlistconcat = this.userlistconcat + ';' + userCode
      // // Aquí puedes mostrar un mensaje de confirmación
      // const confirmDelete = confirm(`¿Estás seguro de que deseas eliminar el usuario con código ${userCode}?`);
      // if (!confirmDelete) {
      //   event.cancel = true;
      // } else {
      //   this.deleteUser(userCode);
      // }
    }
  
private hasExpectedColumnCount(
  sql: string,
  expected: number
): boolean {

  const lowerSql = sql.toLowerCase();

  const selectIndex = lowerSql.indexOf('select');
  const fromIndex = lowerSql.indexOf('from');

  if (
    selectIndex === -1 ||
    fromIndex === -1 ||
    fromIndex <= selectIndex
  ) {
    return false;
  }

  const columnsText = sql
    .substring(selectIndex + 6, fromIndex)
    .trim();

  const columns = columnsText
    .split(',')
    .map(col => col.trim());

  return columns.length === expected;
}
}
